import * as React from 'react';
import { useBranding } from '@/contexts/branding-context';
import { resolveDocumentTitleForPath } from '@/lib/document-title';

/**
 * Sync `document.title` on route change and branding updates.
 *
 * Receives `pathname` as a prop from `App.tsx` so SPA navigation events
 * (hash changes, pushState/replaceState) are caught immediately.
 *
 * Mounted inside `BrandingProvider` in `App.tsx` so login and admin pages
 * both derive their tab title from the permission catalog + brand name.
 */
export function DocumentTitle({ pathname }: { pathname: string }): null {
  const { branding } = useBranding();

  React.useEffect(() => {
    document.title = resolveDocumentTitleForPath(pathname, branding.brandName);
  }, [pathname, branding.brandName]);

  return null;
}
